module.exports = __webpack_public_path__ + "static/media/monster_green.70e1d5e0.png";